import * as api from "@/api";
import UserListBase from "@/components/UserListBase";

const UserList = () => <UserListBase queryKey="users" queryFn={api.getUsers} onAddUser={api.registerUser} />;

export default UserList;
